import React from 'react';
import CustomTable from '../../../blueplanitUtils/CustomTabels';
import { useSelector } from 'react-redux';
export const EmployeeMapIng = () => {
    
  const AllEmployees = useSelector((state) => state.employee.AllEmployees);
    const clientData = useSelector(state =>state.clients.clientData);

  const matchedEmployees = clientData?.clientName
    ? AllEmployees?.filter(emp =>
        Array.isArray(emp.client) &&
        emp.client.some(c =>
          c?.NameOfClient?.trim()?.toLowerCase() === clientData?.clientName?.trim()?.toLowerCase()
        )
      )?.map(emp => ({
        Name: `${emp.firstname} ${emp.lastname}`,
        email: emp.email,
        number: emp.mobile,
        employeeStatus: emp.employeestatus,
      }))
    : [];

    const clientFields = ["Name"," Email", "Phone Number", "Employee Status"]
    const DataLabel = [ "Name","email", "number",  "employeeStatus"]
    return (
        <>
            <CustomTable
                title="Employee List"
                data={matchedEmployees}
                dataLabel={DataLabel}
                columns={clientFields}
                 Id="emp_info"
                 showEdit={false}
                // dateFieldsMap={DateField}
            />
        </>
    )
}
 
 
 
 